import { CustomReportParamTypes, CustomReportTypes } from '../customReports/constants';

export type CustomReportParamDefinition = {
  label: string,
  mappingName: string,
  name: string,
  query: string,
  type: CustomReportParamTypes,
  value: string,
};

type QueryParamName = CustomReportParamDefinition['name'] // period_name

export type QueryParams = Record<string, string>;

type BaseCustomReportDefinition = {
  reportSetId: string,
  reportSetName: string,
  customReportFlag: boolean,
};

export type CustomReport = BaseCustomReportDefinition & {
  columns: string[],
  customReportType: CustomReportTypes.REPORT,
  defaultOrderBy: string,
  params: Record<string, CustomReportParamDefinition>,
  queryParams: QueryParams,
  rows: string[],
  serverSide: boolean
  sql: string,
}

type CustomReportSet = BaseCustomReportDefinition & {
  customReportType: CustomReportTypes.REPORT_SET,
  reports: string[]
}

export type CustomReportSetWithResolvedReports = Omit<CustomReportSet, 'reports'> & {
  reports: CustomReport[],
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-vars
type UniqueQueryParamId = `${BaseCustomReportDefinition['reportSetId']}${QueryParamName}`; // -4period_name

export type ParamValues = Record<QueryParamName, string>; // { period_name: 'JUL-21' }

export const isReportSet = (
  report: CustomReportSetWithResolvedReports | CustomReportSet | CustomReport
): report is CustomReportSetWithResolvedReports => report.customReportType === CustomReportTypes.REPORT_SET;

export const isSingleReport = (
  report: CustomReportSetWithResolvedReports | CustomReportSet | CustomReport
): report is CustomReport => report.customReportType === CustomReportTypes.REPORT;
